// services/notificationsApi.js
// Thin fetch wrappers for the unread/read/device endpoints. All require the `apikey` header.
const apiUrl = process.env.VUE_APP_API_URL

function authHeaders(apiKey) {
  return { 'Content-Type': 'application/json', 'apiKey': apiKey }
}

// GET /chat-messages/unread -> { count, messages }
export async function getUnread(apiKey) {
  const res = await fetch(`${apiUrl}/chat-messages/unread`, {
    headers: authHeaders(apiKey)
  })
  if (!res.ok) throw new Error(`getUnread failed: ${res.status}`)
  return res.json()
}

// POST /chat-messages/read  body { sessionId } OR { messageIds } -> { marked }
export async function markRead(apiKey, body) {
  const res = await fetch(`${apiUrl}/chat-messages/read`, {
    method: 'POST',
    headers: authHeaders(apiKey),
    body: JSON.stringify(body)
  })
  if (!res.ok) throw new Error(`markRead failed: ${res.status}`)
  return res.json()
}

// POST /devices  body { token, platform } -> { device }
export async function registerDevice(apiKey, token, platform = 'web') {
  const res = await fetch(`${apiUrl}/devices`, {
    method: 'POST',
    headers: authHeaders(apiKey),
    body: JSON.stringify({ token, platform })
  })
  if (!res.ok) throw new Error(`registerDevice failed: ${res.status}`)
  return res.json()
}

// DELETE /devices/:token -> { deleted: true }
export async function deleteDevice(apiKey, token) {
  const res = await fetch(`${apiUrl}/devices/${encodeURIComponent(token)}`, {
    method: 'DELETE',
    headers: authHeaders(apiKey)
  })
  if (!res.ok) throw new Error(`deleteDevice failed: ${res.status}`)
  return res.json()
}
